import grapesjs from 'grapesjs';
import loadComponents from './components';
import loadBlocks from './blocks';
import { countdownRef } from './consts';
import mixin from '../../mixins/Mixin';

export default grapesjs.plugins.add('display-countdown-plugin', (editor, opts = {}) => {
  let c = opts;
  let defaults = {
    blocks: [countdownRef],
    labelstartfrom: 'Date cible',
    // Default style
    defaultStyle: true,

    // Default start time, eg. '2018-01-25 00:00'
    startTime: '',

    // Text to show when the countdown is ended
    endText: JSON.parse(
      JSON.stringify(mixin.methods.getLangCode('display-countdown-plugin').translate.endText),
    ),
    countdown1: JSON.parse(
      JSON.stringify(mixin.methods.getLangCode('display-countdown-plugin').translate.countdown1),
    ),
    countdown2: JSON.parse(
      JSON.stringify(mixin.methods.getLangCode('display-countdown-plugin').translate.countdown2),
    ),
    countdown3: JSON.parse(
      JSON.stringify(mixin.methods.getLangCode('display-countdown-plugin').translate.countdown3),
    ),
    // Date input type, eg, 'date', 'datetime-local'
    dateInputType: 'date',

    // Countdown class prefix
    countdownClsPfx: 'countdown',
    textBefore: JSON.parse(
      JSON.stringify(mixin.methods.getLangCode('display-countdown-plugin').translate.textBefore),
    ),
    textAfter: JSON.parse(
      JSON.stringify(mixin.methods.getLangCode('display-countdown-plugin').translate.textAfter),
    ),
    // Countdown label
    labelCountdown: 'Countdown',

    // Countdown category label
    labelCountdownCategory: 'Extra',

    // Days label text used in component
    labelDays: JSON.parse(
      JSON.stringify(mixin.methods.getLangCode('display-countdown-plugin').translate.labelDays),
    ),

    // Hours label text used in component
    labelHours: JSON.parse(
      JSON.stringify(mixin.methods.getLangCode('display-countdown-plugin').translate.labelHours),
    ),

    // Minutes label text used in component
    labelMinutes: JSON.parse(
      JSON.stringify(mixin.methods.getLangCode('display-countdown-plugin').translate.labelMinutes),
    ),

    // Seconds label text used in component
    labelSeconds: JSON.parse(
      JSON.stringify(mixin.methods.getLangCode('display-countdown-plugin').translate.labelSeconds),
    ),
  };

  // Load defaults
  for (let name in defaults) {
    if (!(name in c)) c[name] = defaults[name];
  }

  // Add components
  loadComponents(editor, c);

  // Add components
  loadBlocks(editor, c);
});



// WEBPACK FOOTER //
// ./src/plugins/countDown/index.js